import "./scss/index.scss";

import * as React from "react";
import { Layout, MetaWrapper } from "../../components";
import { maybe } from "@core/utils";
import { gql, useQuery } from "@apollo/client";
import { post } from "../../ssr/graphql/models/post";
import Page from "./Page";
import { Spinner } from "@chakra-ui/spinner";

const GET_POST = gql`
    query Post($slug: String!) {
        postBy(slug: $slug) {
            ${post}
        }
    }
`;

export const Preview: React.FC<any> = ({ slug }) => {
  const { loading, error, data } = useQuery(GET_POST, {
    variables: { slug },
  });

  if (!data?.postBy) {
    return <Spinner />;
  }

  const page = {
    ...data.postBy,
    contentJson: maybe(() => JSON.parse(data.postBy.contentJson), ""),
  };
  return (
    <Layout
      metaTitle={page.seoTitle}
      metaDescription={page.seoTitle}
      categories={[]}
      loading={loading}
      tags={[]}
      isPreview
    >
      <Page breadcrumbs={null} suggestedPosts={[]} page={page} />
    </Layout>
  );
};
export default Preview;
